import SiteTemplate from '@/etc/SiteTemplate';

export default class AbstractController {
    constructor() {
        this.site = new SiteTemplate();
        this.loadLazyComponents();
        this.bindReachGoalTrigger();
    }

    /**
     * To init components from inline scripts. Example:
     * window.pageController.loadComponent('ServiceForm', (module) => new module.default($('.service-claim-form')));
     *
     * @param componentName
     * @param callback
     * @returns {Promise<void>}
     */
    async loadComponent(componentName, callback) {
        let module;

        switch (componentName) {
            //case 'ServiceForm':
            //    module = await import(
            //        /* webpackChunkName: "ServiceForm" */
            //        'component/ServiceForm'
            //        );
            //    break;

            default:
                console.error('Unknown component');
                return;
        }

        callback(module);
    }

    loadLazyComponents() {
        $('[data-loadComponent]').each((index, el) => {
            const componentName = $(el).attr('data-loadComponent');

            let params = $(el).get(0).dataset.params;

            if (params) {
                params = JSON.parse(params);
            } else {
                params = {};
            }

            this.loadComponent(componentName, (module) => {
                new module.default($(el), params);
            });
        });
    }

    bindReachGoalTrigger() {
        $(document.body).on('click', '.js-reach-goal', e => this.reachGoal(e.target.dataset.goal));
    }

    reachGoal(goalId) {
        if (!window.appData.metrikaId) {
            return;
        }

        try {
            // For old counter
            window['yaCounter' + window.appData.metrikaId].reachGoal(goalId);
            // For new counter
            //ym(window.pageData.metrikaId, 'reachGoal', goalId);
        } catch {}
    }
}